import { styled } from '@mui/system';
import { Table } from '@mui/material';

export const StyledTable = styled(Table, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ loading }) => ({
  minWidth: 700,
  '& th': {
    padding: '14px 14px 14px 22px',
    color: '#667'
  },
  '& td': {
    padding: '14px 14px 14px 22px'
  },
  ...(loading && {
    '& tbody tr': {
      filter: 'blur(5px)',
      height: 54
    },
    '& tbody th, & tbody td': {
      animation: 'blink 1.5s alternate infinite linear'
    },
    '@keyframes blink': {
      from: {
        opacity: 1
      },
      to: {
        opacity: 0.2
      }
    }
  })
}));
